document.addEventListener("DOMContentLoaded", function () {
  const cordLabel = document.getElementById("ll-selected-cord");
  const customCaratSelect = document.getElementById("ll-custom-carat");
  const customCertRadios = document.querySelectorAll('input[name="ll_custom_cert"]');
  const settingRadios = document.querySelectorAll('input[name="properties[Setting]"]');
  const housingRadios = document.querySelectorAll('input[name="properties[Housing Metal]"]');

  let productConfig = {
    cordAsVariant: false,
    defaultCord: "Black",
    productHandle: "matchy-pear",
    optionPositions: { cord: 1, carat: 2, cert: 3 },
  };
  let variants = [];

  try {
    const configEl = document.getElementById("MatchyProductConfig");
    if (configEl) productConfig = JSON.parse(configEl.textContent);
  } catch (e) {
    console.warn("Could not parse MatchyProductConfig", e);
  }

  try {
    const variantDataEl = document.getElementById("MatchyVariantData");
    if (variantDataEl) variants = JSON.parse(variantDataEl.textContent);
  } catch (e) {
    console.warn("Could not parse MatchyVariantData", e);
  }

  const cordAsVariant = Boolean(productConfig.cordAsVariant);
  const optionPositions = productConfig.optionPositions || { cord: 1, carat: 2, cert: 3 };

  function normalizeValue(value) {
    return (value || "").replace(/\s+/g, "").toLowerCase();
  }

  function normalizeCert(value) {
    return (value || "").toLowerCase().replace(/[\s-]/g, "");
  }

  function normalizeCarat(value) {
    return (value || "").toLowerCase().replace(/\s+/g, "");
  }

  function getVariantOption(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function isVariantCordMode() {
    return cordAsVariant && document.querySelector('input[name="ll_custom_cord"]');
  }

  function getSelectedCord() {
    const variantRadio = document.querySelector('input[name="ll_custom_cord"]:checked');
    if (variantRadio) return variantRadio.value;

    const propertyRadio = document.querySelector('input[name="properties[Cord Color]"]:checked');
    if (!propertyRadio) return productConfig.defaultCord || "Black";

    const swatch = propertyRadio.nextElementSibling;
    return swatch ? swatch.getAttribute("data-name") || propertyRadio.value : propertyRadio.value;
  }

  function getSelectedCarat() {
    return customCaratSelect ? customCaratSelect.value : "";
  }

  function getSelectedCert() {
    const checked = document.querySelector('input[name="ll_custom_cert"]:checked');
    return checked ? checked.value : "";
  }

  function setCordSelection(cordName) {
    if (!cordName) return;

    document.querySelectorAll('input[name="ll_custom_cord"]').forEach((radio) => {
      if (radio.value === cordName) radio.checked = true;
    });

    document.querySelectorAll('input[name="properties[Cord Color]"]').forEach((radio) => {
      const radioValue = radio.nextElementSibling?.getAttribute("data-name") || radio.value;
      if (radioValue === cordName) radio.checked = true;
    });

    if (cordLabel) {
      const checked = document.querySelector('input[name="ll_custom_cord"]:checked, input[name="properties[Cord Color]"]:checked');
      const swatch = checked ? checked.nextElementSibling : null;
      const cordText = swatch
        ? swatch.getAttribute("data-display") || swatch.getAttribute("data-name") || cordName
        : cordName;
      cordLabel.textContent = (window.llCordLabel ? window.llCordLabel(cordText) : cordText);
    }
  }

  function setCaratSelection(caratValue) {
    if (!customCaratSelect || !caratValue) return;
    const normalized = normalizeCarat(caratValue);
    Array.from(customCaratSelect.options).forEach((opt) => {
      if (normalizeCarat(opt.value) === normalized) {
        customCaratSelect.value = opt.value;
      }
    });
  }

  function setCertSelection(certValue) {
    if (!certValue) return;
    const normalized = normalizeCert(certValue);
    customCertRadios.forEach((radio) => {
      if (normalizeCert(radio.value) === normalized) {
        radio.checked = true;
      }
    });
  }

  function findMatchingVariant() {
    const caratVal = normalizeCarat(getSelectedCarat());
    const certVal = normalizeCert(getSelectedCert());
    const cordVal = normalizeValue(getSelectedCord());

    if (isVariantCordMode()) {
      const cordPos = optionPositions.cord || 1;
      const caratPos = optionPositions.carat || 2;
      const certPos = optionPositions.cert || 3;

      return variants.find((v) => {
        return (
          normalizeValue(getVariantOption(v, cordPos)) === cordVal &&
          normalizeCarat(getVariantOption(v, caratPos)) === caratVal &&
          normalizeCert(getVariantOption(v, certPos)) === certVal
        );
      });
    }

    return variants.find((v) => {
      const o1 = normalizeCarat(v.option1);
      const o2 = normalizeCert(v.option2);
      const o2carat = normalizeCarat(v.option2);
      const o1cert = normalizeCert(v.option1);
      const matches = (o1 === caratVal && o2 === certVal) || (o2carat === caratVal && o1cert === certVal);
      return v.option2 ? matches : o1 === caratVal || o2 === certVal;
    });
  }

  function formatCordSlug(selectedCord, productHandle) {
    let cordFmt = selectedCord.toLowerCase().replace(/ /g, "-");
    const filenameMap = {
      "turq-blue": "turquoise",
      navy: "navy-blue",
      grey: "silver-grey",
      "yellow-gold": "gold",
      gold: "gold",
    };
    if (filenameMap[cordFmt]) {
      cordFmt = filenameMap[cordFmt];
    }
    if (cordFmt === "yellow-gold" && (productHandle.includes("heart") || productHandle.includes("emerald"))) {
      cordFmt = "gold";
    }
    return cordFmt;
  }

  function getProductHandle() {
    const handle = productConfig.productHandle || window.MATCHY_PRODUCT_HANDLE || "matchy-pear";
    if (productConfig.isNecklace || handle.includes("necklace")) {
      return handle.includes("necklace") ? handle : `${handle}-necklace`;
    }
    return handle.replace("-necklace", "");
  }

  function buildThemeAssetUrl(setting, housing, cordFmt) {
    const sample = productConfig.galleryAssetSample || window.SHOPIFY_ASSET_URL;
    if (!sample) return null;

    const productHandle = getProductHandle();
    const newBase = `${productHandle}-${setting}-${housing}-${cordFmt}`;

    try {
      const url = new URL(sample, window.location.origin);
      const parts = url.pathname.split("/");
      const oldFilename = parts.pop() || "";
      const extMatch = oldFilename.match(/\.(png|webp)$/i);
      const ext = extMatch ? extMatch[0] : ".png";
      parts.push(`${newBase}${ext}`);
      url.pathname = parts.join("/");
      return url.toString();
    } catch (e) {
      return sample.replace(/matchy-[a-z\-]+-(bezel|prong)-[a-z\-]+-[a-z\-]+\.(png|webp)/i, `${newBase}$2`);
    }
  }

  function updateGalleryImage() {
    const selectedCord = getSelectedCord();
    let selectedSetting = "bezel";
    let selectedHousing = "white-white";

    settingRadios.forEach((radio) => {
      if (radio.checked && !radio.disabled) selectedSetting = radio.value;
    });
    housingRadios.forEach((radio) => {
      if (radio.checked && !radio.disabled) selectedHousing = radio.value;
    });

    if (selectedSetting === "prong") {
      if (selectedHousing === "white") selectedHousing = "white-white";
      if (selectedHousing === "yellow") selectedHousing = "yellow-yellow";
    }

    if (cordLabel) cordLabel.textContent = (window.llCordLabel ? window.llCordLabel(selectedCord) : selectedCord);

    const mainImage = document.getElementById("ll-cuty-main-image") || document.querySelector(".product__media img");
    if (!mainImage) return;

    const productHandle = getProductHandle();
    const cordFmt = formatCordSlug(selectedCord, productHandle);
    const newUrl = buildThemeAssetUrl(selectedSetting, selectedHousing, cordFmt);
    if (!newUrl || mainImage.src === newUrl) return;

    const altExt = newUrl.includes(".webp") ? ".png" : ".webp";
    const candidates = [newUrl, newUrl.replace(/\.(webp|png)$/i, altExt)];
    const cordAlternates = {
      "silver-grey": "grey",
      grey: "silver-grey",
      navy: "navy-blue",
      "navy-blue": "navy",
      gold: "yellow-gold",
      "yellow-gold": "gold",
    };
    if (cordAlternates[cordFmt]) {
      const altCordUrl = buildThemeAssetUrl(selectedSetting, selectedHousing, cordAlternates[cordFmt]);
      if (altCordUrl) {
        candidates.push(altCordUrl);
        candidates.push(altCordUrl.replace(/\.(webp|png)$/i, altExt));
      }
    }

    if (window.llLoadProductImage) {
      window.llLoadProductImage(mainImage, candidates.filter(Boolean), { setSrcset: true });
      return;
    }

    const tryLoad = (urls) => {
      if (!urls.length) return;
      const next = urls[0];
      const tempImg = new Image();
      tempImg.onload = function () {
        mainImage.src = next;
        mainImage.srcset = next;
      };
      tempImg.onerror = function () {
        tryLoad(urls.slice(1));
      };
      tempImg.src = next;
    };
    tryLoad(candidates.filter(Boolean));
  }

  function applyMatchedVariant(matchedVariant) {
    if (!matchedVariant) {
      console.warn("Could not find matching Matchy variant", {
        cord: getSelectedCord(),
        carat: getSelectedCarat(),
        cert: getSelectedCert(),
      });
      return;
    }

    document.querySelectorAll('input.product-variant-id, input[name="id"]').forEach((input) => {
      input.value = matchedVariant.id;
      input.disabled = false;
    });

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", matchedVariant.id);
    window.history.replaceState({}, "", newUrl.toString());

    if (matchedVariant.priceCents != null && window.theme && typeof theme.setProductPrices === 'function') {
      theme.setProductPrices(matchedVariant.priceCents);
    } else if (matchedVariant.price) {
      document.querySelectorAll("[id^='price-'][role='status'] .price-item--regular, [id^='price-'][role='status'] .price-item--sale").forEach((el) => {
        el.innerHTML = matchedVariant.price;
      });
    }

    if (window.updateAllSizeSubmitButtons) {
      window.updateAllSizeSubmitButtons();
    }
  }

  function syncNativeVariantPicker() {
    const matchedVariant = findMatchingVariant();
    applyMatchedVariant(matchedVariant);
    updateGalleryImage();
  }

  function onCordChange() {
    if (isVariantCordMode()) {
      syncNativeVariantPicker();
    } else {
      updateGalleryImage();
    }
  }

  function preselectFromUrlVariant() {
    const urlVariantId = new URL(window.location.href).searchParams.get("variant");
    if (!urlVariantId || !variants.length) return;

    const matchedVariant = variants.find((v) => String(v.id) === String(urlVariantId));
    if (!matchedVariant) return;

    if (isVariantCordMode()) {
      setCordSelection(getVariantOption(matchedVariant, optionPositions.cord || 1));
      setCaratSelection(getVariantOption(matchedVariant, optionPositions.carat || 2));
      setCertSelection(getVariantOption(matchedVariant, optionPositions.cert || 3));
    } else {
      setCaratSelection(matchedVariant.option1);
      setCertSelection(matchedVariant.option2);
    }
  }

  document
    .querySelectorAll('input[name="ll_custom_cord"], input[name="properties[Cord Color]"]')
    .forEach((radio) => radio.addEventListener("change", onCordChange));

  if (settingRadios) {
    settingRadios.forEach((radio) =>
      radio.addEventListener("change", function () {
        setTimeout(updateGalleryImage, 0);
      })
    );
  }
  if (housingRadios) housingRadios.forEach((radio) => radio.addEventListener("change", updateGalleryImage));

  if (customCaratSelect) {
    customCaratSelect.addEventListener("change", syncNativeVariantPicker);
  }

  customCertRadios.forEach((radio) => {
    radio.addEventListener("change", syncNativeVariantPicker);
  });

  preselectFromUrlVariant();
  updateGalleryImage();
  syncNativeVariantPicker();
});
